const INVITATION_STORAGE_KEY = 'invitation-tokens';

export const InvitationTokens = {
  count() {
    return InvitationTokens.getTokens().length;
  },
  hasTokens() {
    return InvitationTokens.getTokens().length > 0;
  },
  getTokens: (): string[] => {
    try {
      const tokens = localStorage.getItem(INVITATION_STORAGE_KEY);
      return tokens ? JSON.parse(tokens) : [];
    } catch {
      return [];
    }
  },
  pushToken: (token: string) => {
    try {
      const tokens = InvitationTokens.getTokens();
      if (!tokens.includes(token)) {
        tokens.push(token);
        localStorage.setItem(INVITATION_STORAGE_KEY, JSON.stringify(tokens));
      }
    } catch {
      localStorage.setItem(INVITATION_STORAGE_KEY, JSON.stringify([token]));
    }
  },
  clearTokens: () => {
    localStorage.removeItem(INVITATION_STORAGE_KEY);
  },
};
